import React from 'react';
import { FaFileImage, FaFilePdf, FaFileLines } from 'react-icons/fa6';
import { FaLongArrowAltRight } from 'react-icons/fa';
import { IFrontTask, ITaskAction } from "../interfaces/ITask";

export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const padZero = (number: number): string => {
  return number.toString().padStart(2, "0");
};

export const objectIdToDate = (objectId: string): string => {
  const timestamp = parseInt(objectId.substring(0, 8), 16) * 1000;
  const date = new Date(timestamp);
  return `${padZero(date.getDate())}/${padZero(date.getMonth() + 1)}/${date.getFullYear()} ${padZero(date.getHours())}:${padZero(date.getMinutes())}:${padZero(date.getSeconds())}`;
};

export const getTaskPriority = (priority: string): string => {
  switch (priority) {
    case "veryHigh":
      return "Altíssima";
    case "high":
      return "Alta";
    case "medium":
      return "Média";
    case "low":
      return "Baixa";
    case "veryLow":
      return "Muito Baixa";
    default:
      return "Em análise";
  }
};

export const getTaskCategory = (category: string): string => {
  switch (category) {
    case "bug":
      return "Correção";
    case "customization":
      return "Customização";
    case "feat":
      return "Nova implementação";
    default:
      return "";
  }
};

export const formatTaskFlow = (flow: string): string => {
  const partes = flow.split("->");
  return partes.map(parte => parte.trim()).join(" → ");
};

export const handleFileType = (link: string): string => {
  if (link.includes("png")) return "image";
  if (link.includes("pdf")) return "pdf";
  return "document";
};

export const getFileIconType = (fileType: string): string => {
  switch (fileType) {
    case "image":
      return "image";
    case "pdf":
      return "pdf";
    default:
      return "document";
  }
};

export const getFileIcon = (fileType: string): any => {
  switch (fileType) {
    case "image":
      return FaFileImage;
    case "pdf":
      return FaFilePdf;
    default:
      return FaFileLines;
  }
}; 

export const censorEmailString = (description:string) => {
  if(!description)return;
  const emailRegex = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/g;
  return description.replace(emailRegex, (match) => {
    const atIndex = match.indexOf('@');
    let splitIndex = atIndex == 1 ? 0 : atIndex-(atIndex-1)
    const visiblePart = match.substring(0, splitIndex); 
    const censoredPart = '*'.repeat(atIndex - splitIndex);
    return `${visiblePart}${censoredPart}${match.substring(atIndex)}`;
  });
};